// lib
import React from 'react'
import PropTypes from 'prop-types'

import { VIEW_OPTIONS_HELP } from '@aytm/app/stats/page/sidebar/components/lib/helps'

// components
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'

import ChartModes from '@aytm/app/stats/page/sidebar/view-options/components/ChartModes'
import Traits from '@aytm/app/stats/page/sidebar/view-options/components/Traits'
import Translations from '@aytm/app/stats/page/sidebar/view-options/components/Translations'
import Params from '@aytm/app/stats/page/sidebar/view-options/components/Params'

import ArtificialResponses from '@aytm/app/stats/page/sidebar/view-options/components/ArtificialResponses'

// styles
import style from '@aytm/app/stats/page/sidebar/view-options/styles/ViewOptionsPanel.module.scss'

const ViewOptionsPanel = ({
  root,
  model,
  data,
  features,
  generatingArtificialResponses,
  disabled,
  onChartModeChange,
  onTraitChange,
  onTranslationChange,
  onParamsChange,
  onToggleQuestions,
  onToggleAllCjLite,
  onGenerateArtificialResponses
}) => (
  <div className={style.component}>
    <div className={style['component-title']}>
      View Options
      <SidebarPopup id="view" root={root} help={VIEW_OPTIONS_HELP} width="300px" />
    </div>

    <ChartModes model={model} features={features} disabled={disabled} onChartModeChange={onChartModeChange} />
    <Traits model={model} data={data} features={features} disabled={disabled} onTraitChange={onTraitChange} />
    <Translations
      root={root}
      model={model}
      data={data}
      features={features}
      disabled={disabled}
      onTranslationChange={onTranslationChange}
    />
    <Params
      model={model}
      features={features}
      disabled={disabled}
      onParamsChange={onParamsChange}
      onToggleQuestions={onToggleQuestions}
      onToggleAllCjLite={onToggleAllCjLite}
    />

    {features.fake_responses.hidden ? null : (
      <ArtificialResponses
        data={data}
        generatingArtificialResponses={generatingArtificialResponses}
        disabled={disabled}
        onGenerateArtificialResponses={onGenerateArtificialResponses}
      />
    )}
  </div>
)

ViewOptionsPanel.propTypes = {
  root: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  generatingArtificialResponses: PropTypes.bool,
  disabled: PropTypes.bool,
  onChartModeChange: PropTypes.func,
  onTraitChange: PropTypes.func,
  onTranslationChange: PropTypes.func,
  onParamsChange: PropTypes.func,
  onToggleQuestions: PropTypes.func,
  onToggleAllCjLite: PropTypes.func,
  onGenerateArtificialResponses: PropTypes.func
}

ViewOptionsPanel.displayName = 'ViewOptionsPanel'

export default ViewOptionsPanel
